import {
  GET_VENDING_MACHINES_EXTERNAL_SERVICES_SETTINGS,
  convertResult,
  convertParams,
} from 'app/common/api/requests/data/vending/machines/external_service_settings/get'

import { useCommonDataProvider, CommonDataOptions } from 'app/dataProviders/useCommonDataProvider'

import { VendingMachineExternalServiceSettings, Params, isParamsValid, ExternalServiceSettings } from 'app/dataTypes/vending/machine/externalServices'

const defaultState: ExternalServiceSettings = {
  enableExternalServices: false,
  services: []
}

type Op = CommonDataOptions<Array<VendingMachineExternalServiceSettings>, Params>

export function useVendingMachineExtServicesSettings(options: Op) {
  const res = useCommonDataProvider({
    ...options,
    requestValue: GET_VENDING_MACHINES_EXTERNAL_SERVICES_SETTINGS,
    error: 'Не удалось получить настройки внешних сервисов у машины вендинга',
    convertions: {
      convertResult,
      convertParams,
    },
    defaultState,
    isParamsValid
  })

  return res
}
